import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import Layout from '../components/feature/Layout';

const HomePage        = lazy(() => import('../pages/home/page'));
const AboutPage       = lazy(() => import('../pages/about/page'));
const BuyingPage      = lazy(() => import('../pages/buying/page'));
const SellingPage     = lazy(() => import('../pages/selling/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));
const GiveawayPage    = lazy(() => import('../pages/giveaway/page'));
const ContactPage     = lazy(() => import('../pages/contact/page'));
const ResourcesPage   = lazy(() => import('../pages/resources/page'));
const AreasPage       = lazy(() => import('../pages/areas/page'));
const NotFoundPage    = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: '/',             element: <HomePage /> },
      { path: '/about',        element: <AboutPage /> },
      { path: '/buying',       element: <BuyingPage /> },
      { path: '/selling',      element: <SellingPage /> },
      { path: '/testimonials', element: <TestimonialsPage /> },
      { path: '/giveaway',     element: <GiveawayPage /> },
      { path: '/contact',      element: <ContactPage /> },
      { path: '/resources',    element: <ResourcesPage /> },
      { path: '/areas',        element: <AreasPage /> },
      { path: '*',             element: <NotFoundPage /> },
    ],
  },
];

export default routes;
